export const widgetDefaultPositions = Object.fromEntries(
  [
    {
      id: 'whats_new',
      grid: {
        x: 1,
        y: 55,
        cols: 1,
        rows: 16,
      },
      isEnabled: true,
    },
    {
      id: 'recents',
      grid: {
        x: 0,
        y: 0,
        cols: 2,
        rows: 4,
      },
      isEnabled: true,
    },
    {
      id: 'upcoming_events',
      grid: {
        x: 0,
        y: 4,
        cols: 2,
        rows: 19,
      },
      isEnabled: true,
    },
    {
      id: 'new_candidates',
      grid: {
        x: 0,
        y: 39,
        cols: 1,
        rows: 16,
      },
      isEnabled: true,
    },
    {
      id: 'overdue_candidates',
      grid: {
        x: 1,
        y: 39,
        cols: 1,
        rows: 16,
      },
      isEnabled: true,
    },
    {
      id: 'applied_candidates',
      grid: {
        x: 0,
        y: 23,
        cols: 2,
        rows: 16,
      },
      isEnabled: true,
    },
    {
      id: 'job_overview',
      grid: {
        x: 0,
        y: 55,
        cols: 1,
        rows: 16,
      },
      isEnabled: true,
    },
    {
      id: 'discover',
      grid: {
        x: 0,
        y: 71,
        cols: 2,
        rows: 16,
      },
      isEnabled: true,
    },
    {
      id: 'tags_and_sources',
      grid: {
        x: 1,
        y: 55,
        cols: 1,
        rows: 16,
      },
      isEnabled: true,
    },
  ].map(widget => [widget.id, widget]),
);
